import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { IImmoCalcHouse } from '../interfaces/IImmoCalcHouse';

@Component({
  selector: 'my-house-apartments',
  templateUrl: 'my-house-apartments.page.html',
  styleUrls: ['my-house-apartments.page.scss']
})
export class MyHouseApartmentsPage {
  houses: IImmoCalcHouse[] = [];
  activeHouse: IImmoCalcHouse;
  houseId: string;


  constructor(private storage: Storage,
    private router: Router,
    private route: ActivatedRoute) {

    route.params.subscribe(async val => {
      this.houseId = this.route.snapshot.paramMap.get('houseId');

      await this.storage.create();

      this.houses = await this.storage.get('houses');
      if (!this.houses || !this.houses.length) {
        this.houses = [];
        await this.storage.set('houses', this.houses);

      }

      const houses = this.houses.filter(h => h.id == this.houseId);
      if (!houses || !houses.length) {
        this.houseId = 'error';
      }
      else {
        this.activeHouse = houses[0];
      }
    });

  }

  ngOnInit() {
    this.houseId = this.route.snapshot.paramMap.get('houseId');
  }

  getHouseName() {
    if (this.activeHouse && this.activeHouse.name) {
      return this.activeHouse.name;
    }
    else return '';
  }

}
